import { useEffect } from "react";

const useScrollToTop = () => {
  useEffect(() => {
    document.body.scrollIntoView();
  }, []);
};

export default useScrollToTop;
